import Konva from 'konva/konva'
import EventCluster from './event-cluster'
import { timeToX } from '../utils'

const eventsHeight = 90
const marginBottom = 5

export default class EventLayer extends Konva.Layer {
  constructor ({ name }) {
    super({ name })
  }

  init ({ width, yFrom, yTo, timeFrom, timeTo, data, setFixedTime }) {
    Object.assign(this, { width, yFrom, yTo, timeFrom, timeTo, data, setFixedTime })

    this._timeToXPartial = time => timeToX({ timeFrom, timeTo, width, time })

    this._calculateEventClusters()
    this.render()
  }

  get height () {
    return eventsHeight + marginBottom
  }

  _calculateEventClusters () {
    const events = EventLayer._extractEventsFromData(this.data)
    this.eventClusters = EventLayer._clusterEvents(this._timeToXPartial, events)
  }

  static _extractEventsFromData (data) {
    const events = []
    data.forEach(asset => {
      asset.variables
        .filter(variable => variable.type === 'event')
        .forEach(variable => {
          variable.values.forEach(tuple => {
            events.push({
              time: tuple[0],
              assetName: asset.name,
              variableName: variable.name,
              values: tuple[1]
            })
          })
        })
    })
    events.sort((a, b) => a.time - b.time)
    return events
  }

  static _clusterEvents (timeToXPartial, events) {
    const eventClusters = []
    let cluster = { eventId: 0, events: [] }
    let firstEventInCluster = null
    events.forEach(event => {
      if (firstEventInCluster !== null) {
        const firstEventInClusterX = timeToXPartial(firstEventInCluster.time)
        const eventX = timeToXPartial(event.time)
        if (!EventCluster.eventsOverlap(firstEventInClusterX, eventX)) {
          eventClusters.push(cluster)
          cluster = { eventId: 0, events: [] }
        }
      }
      if (cluster.events.length === 0) {
        firstEventInCluster = event
      }
      cluster.events.push(event)
    })
    if (events.length) {
      eventClusters.push(cluster)
    }
    return eventClusters
  }

  render () {
    this.destroyChildren()

    this.eventClusters.forEach((eventCluster, clusterId) => {
      this._renderEventCluster(eventCluster, clusterId)
    })

    this.draw()
  }

  _renderEventCluster (eventCluster, clusterId) {
    const { yFrom, yTo, setFixedTime } = this
    const { eventId } = eventCluster

    const events = eventCluster.events.map(event =>
      ({ ...event, x: this._timeToXPartial(event.time) }))

    const cluster = new EventCluster({
      yFrom,
      yTo,
      clusterId,
      eventId,
      events,
      cycleEvent: this.cycleEvent.bind(this),
      setFixedTime
    })
    cluster.render()
    this.add(cluster)
  }

  cycleEvent (clusterId, newEventId) {
    this.eventClusters = this.eventClusters
      .map(({ eventId, events }, index) => ({
        eventId: (index === clusterId) ? newEventId : eventId,
        events
      }))
    this.render()
  }
}
